import React from 'react';
import PropTypes from 'prop-types';

const Loader = props => (
  <div className={`loader-container ${props.additionalContainerClass}`}>
    <div className={`loader ${props.additionalClass}`}>
      <div className="inner-loader" />
    </div>
  </div>
);

Loader.propTypes = {
  additionalClass: PropTypes.string,
  additionalContainerClass: PropTypes.string,
};

Loader.defaultProps = {
  additionalClass: '',
  additionalContainerClass: '',
};

export default Loader;
